import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LinkContainer } from "react-router-bootstrap";
import { faCode } from '@fortawesome/free-solid-svg-icons';
import "./NotFound.css";

export default function NotFound() {
  return (
    <div className="flexVCenterContainer flex-column">
      <FontAwesomeIcon icon={faCode} size="3x" />
      <h1>Seite nicht gefunden!</h1>
      <LinkContainer to="/">
        <button className="btn-link">
          &laquo; Zurück zur Hauptseite
        </button>
      </LinkContainer>
    </div>
  );
}

